import countries from 'i18n-iso-countries'

import seminarTypes from './seminarTypes'
import type { RawSeminar, Seminar } from './types'

countries.registerLocale(require('i18n-iso-countries/langs/en.json')) // eslint-disable-line @typescript-eslint/no-var-requires

function parseTranslations(translations?: string | string[]) {
  if (!translations) {
    return []
  } else if (Array.isArray(translations)) {
    return translations
  } else {
    return [translations]
  }
}

export default function parse(rawSeminar: RawSeminar): Seminar {
  const {
    city,
    state,
    country,
    name: courseName,
    isOnline,
    isWaitlisted: waitListed,
    status,
    seminarUrl: url,
    seminarType: seminarTypeNumber,
    locationName,
    address,
    currency,
    id,
    locationUrl,
    startDate,
    postalCode,
    endDate,
    language,
    translations,
  } = rawSeminar

  const isWaitListed = waitListed === true || waitListed === 'true'
  const isOnlineSeminar = isOnline === '1'
  const isOpen = status === 'Active'

  // Online seminars are considered "sold out" if waitlisted and are not
  // available for any form of registration
  const isAvailable = isOpen && !(isOnlineSeminar && isWaitListed)

  const location = [city, state, country].filter(Boolean).join(', ')

  const { shortName, metaType, urlBase, dailyListShortName } = seminarTypes[
    seminarTypeNumber
  ]
  const countryLong = country ? countries.getName(country, 'en') : undefined

  const detailsPageUrl = `${urlBase}/${id}`

  return {
    language: language || 'en',
    translations: parseTranslations(translations),
    metaType,
    currency,
    id,
    locationUrl,
    startDate,
    postalCode,
    endDate,
    address,
    locationName,
    city,
    state,
    country,
    location,
    courseName,
    isAvailable,
    isOnlineSeminar,
    isOpen,
    isWaitListed,
    shortName,
    countryLong,
    url,
    detailsPageUrl,
    dailyListShortName,
  }
}
